import { useAtom } from 'jotai';
import { languageAtom } from '@/stores/atoms/i18nAtoms';
const zhCN = {
    'search': '搜索',
    'search.saves': '搜索存档',
    'edit': '编辑',
    'you': '你',
    'mine_game_name': '我的作品',
    'language': '语言',
    'language.zh-CN': '中文',
    'language.en-US': 'English',
    'message_style.menu_label': '消息渲染风格',
    'message_style.standard_markdown': '标准 Markdown',
    'message_style.beautified': '美化风格',
    'message_style.framed': '框体风格',
    'message_style.messager': 'Messager 风格',
    'placeholder.type_message': '你想做什么…',
    'placeholder.initializing': '正在初始化会话…',
    'placeholder.select_script': '请选择剧本后开始对话',
    'back': '返回',
    'search.title': '搜索',
    'search.placeholder': '搜索剧本或描述…',
    'nav.home': '首页',
    'nav.chat': '书架',
    'nav.create': '创建',
    'nav.profile': '个人',
    'profile.title': '个人信息',
    'profile.uploadAvatar': '上传头像',
    'profile.displayName': '称谓',
    'profile.language': '语言',
    'profile.save': '保存',
    'settings.title': '设置',
    'settings.privacy': '隐私与安全',
    'settings.telemetry': '允许匿名使用数据（改进产品）',
    'settings.dataRetention': '数据保留期限',
    'settings.retention.never': '不自动清理',
    'settings.privacyPolicy': '隐私政策',
    'settings.dataControl': '数据与账户控制',
    'settings.dataControlDesc': '你可以导出或删除本地数据，或删除账户与数据。',
    'settings.deleteData': '删除本地数据',
    'settings.deleteDataConfirm': '确认删除本地存档、对话、作品等所有本地数据？该操作不可撤销。',
    'settings.deleted': '已删除',
    'settings.deletedMsg': '本地数据已清理。',
    'settings.deleteAccount': '删除账号与数据',
    'settings.deleteAccountConfirm': '确认删除账号与相关数据？在当前版本中将删除本地数据。',
    'settings.usCompliance': '遵循适用的美国隐私法规（如 CCPA），我们提供清晰的数据控制与删除选项。',
    'profile.myGames': '我发布的游戏',
    'profile.mySessions': '我的存档记录',
    'profile.myFavorites': '我的收藏',
    'profile.noGames': '暂无作品',
    'profile.noSessions': '暂无存档',
    'profile.noFavorites': '暂无收藏',
    'html.loading': 'HTML 加载中…',
    'html.expand': '展开 HTML 内容',
    'html.collapse': '收起 HTML 内容',
    'chatHistory.empty.title': '暂无任何存档',
    'chatHistory.empty.subtitle': '从首页选择一个游戏开始',
    'chatHistory.createNew': '创建新存档',
    'chatHistory.confirmCreate': '确认在此游戏创建一个新的存档？',
    'chatHistory.title': '书架',
    'chatHistory.rename': '重命名',
    'chatHistory.delete': '删除',
    'chatHistory.confirmDelete': '确认删除该存档吗？',
    // Bookshelf sections
    'bookshelf.section.recent': '最近阅读',
    'bookshelf.section.monthAgo': '一个月以前',
    'bookshelf.section.yearAgo': '1年以前',
    'create.title.edit': '编辑我的作品',
    'create.title.new': '创建新的冒险',
    'create.placeholder.title': '作品标题',
    'create.placeholder.content': '写下开场故事、世界观、设定等…',
    'create.save': '保存',
    'create.saveDraft': '保存草稿',
    'create.submit': '提交',
    'create.prompt.placeholder': '编写 Prompt（用于引导生成）',
    'create.prologue.placeholder': '编写开场 Prologue（故事开篇）',
    'create.help.cover': '封面图：点击右上角图片图标上传，作为列表与背景展示，建议横图且清晰。',
    'create.help.title': '标题将用于展示与搜索，建议简短有力、突出主题。',
    'create.help.prompt': 'Prompt 用于指导模型生成风格/世界观，请尽量具体明确。',
    'create.help.prologue': 'Prologue 是用户进入时看到的开场内容，用来设定氛围与剧情起点。',
    'confirm.ok': '确认',
    'confirm.cancel': '取消',
    // Errors
    'error.title': '出错了',
    'error.categories.load': '加载类目失败，请稍后重试。',
    'error.adventures.load': '加载冒险列表失败，请稍后重试。',
    'error.session.delete': '删除存档失败',
    // WebSocket
    'ws.connecting': '正在连接服务器…',
    'ws.reconnecting': '连接断开，正在重试…（第 {n} 次）',
    'ws.disconnected': '连接已断开',
    'ws.retry': '重新连接',
    // Common
    'common.expand': '展开',
    'common.collapse': '收起',
    'common.next': '下一步',
    'common.prev': '上一步',
    'common.selected': '已选择',
    'common.chooseImage': '选择图片',
    'common.loading': '加载中…',
    // Favorites
    'favorite.add': '收藏',
    'favorite.remove': '取消收藏',
    // Profile
    'profile.signOut': '退出登录',
    'profile.user': '用户',
    'profile.loginRequired': '请先登录',
    // Create/Editor
    'create.field.titleLabel': '标题',
    'create.section.promptTitle': '世界卡',
    'create.section.gameTypeTitle': '游戏类型',
    'create.section.step3Title': '场景卡与角色卡',
    'create.section.step4Title': '命名与封面',
    'create.gameType.placeholder': '选择游戏类型',
    'create.gameType.AVG': 'AVG（文字冒险）',
    'create.gameType.SIM': 'SIM（模拟经营）',
    'create.gameType.RPG': 'RPG（角色扮演）',
    'create.gameType.CUSTOM': '自定义（可自由设计UI）',
    'create.step2.subtitle': '填写设定与开场',
    'create.step3.characters': '角色卡',
    'create.step3.addCharacter': '添加角色',
    'create.step3.scenes': '场景卡',
    'create.scene.mainInitial': '主角初始场景',
    'create.scene.mainInitial.yes': '是',
    'create.scene.mainInitial.no': '否',
    'create.character.initialScene': '初始场景',
    'create.step3.addScene': '添加场景',
    'create.character.name': '角色名称',
    'create.character.description': '角色设定',
    'create.character.image': '角色图片',
    'create.scene.name': '场景名称',
    'create.scene.description': '场景介绍',
    'create.scene.image': '场景图片',
    'create.scene.connections': '场景连接',
    'create.scene.connections.tip': '从此场景可以到达的其他场景',
    'create.modal.add': '添加',
    'create.modal.save': '保存',
    'create.modal.cancel': '取消',
    'create.modal.edit': '编辑',
    'create.tip.customUiOnly': '仅自定义类型可编辑界面代码',
    'create.cover.title': '封面/背景图片',
    'create.cover.tip': '建议横图且清晰',
    'create.cover.chosenBadge': '已选择',
    'create.cover.pickImage': '选择图片',
    'create.category.title': '选择类目',
    'create.category.tip': '用于分类和推荐',
    'create.category.placeholder': '选择游戏类目',
    'create.category.empty': '无类目',
    'create.advanced.title': '高级选项',
    'create.advanced.subtitle': '自定义界面代码（可选）',
    'create.advanced.uiCodeLabel': '游戏界面代码（可选）',
    'create.advanced.uiCodePlaceholder': '粘贴或编写 UI 代码（可留空）',
    'create.advanced.openDesigner': '打开界面设计器',
    // Create assets
    'create.assets.title': '创建素材',
    'create.assets.tip': '上传图片并复制链接，用于 UI 设计器',
    'create.assets.upload': '上传素材图片',
    'create.assets.listEmpty': '暂无素材',
    'create.assets.copy': '复制链接',
    'create.assets.copied': '已复制',
    'create.assets.uploadedMsg': '素材已上传',
    'create.prologue.title': '开场白',
    'create.prologue.tip': '故事开篇',
    'create.submit.success': '提交成功',
    'create.submit.failed': '提交失败',
    'create.image.uploaded': '上传成功',
    'create.image.coverUpdated': '封面已更新',
    'create.image.uploadFailed': '上传失败',
    'error.network': '网络错误',
    'create.draftSaved': '草稿已保存',
    'create.exitConfirm': '确认退出编辑？未保存的更改将作为草稿保留。',
    'create.submit.missingFields': '请完善标题、开场与封面后再提交',
    'error.deleteFailed': '删除失败',
    // UI Designer
    'uiDesigner.title': '界面设计器',
    'uiDesigner.preview.placeholder': '这里显示聊天示例……',
    'uiDesigner.sample.userHello': '玩家：你好！',
    'uiDesigner.sample.welcome': '系统：欢迎来到界面设计器预览。',
    'uiDesigner.input.placeholder': '输入测试内容…',
    'uiDesigner.send': '发送',
    // Settings extras
    'settings.reauthRequired': '请先重新登录后再尝试删除账号。',
    // Auth
    'auth.login': '登录',
    // Misc
    'common.all': '全部',
    'home.refreshed': '已刷新',
};
const enUS = {
    'search': 'Search',
    'search.saves': 'Search saves',
    'edit': 'Edit',
    'you': 'You',
    'mine_game_name': 'MineGame',
    'language': 'Language',
    'language.zh-CN': '中文',
    'language.en-US': 'English',
    'message_style.menu_label': 'Message Style',
    'message_style.standard_markdown': 'Standard Markdown',
    'message_style.beautified': 'Beautified Style',
    'message_style.framed': 'Framed Style',
    'message_style.messager': 'Messager Style',
    'placeholder.type_message': 'What do you do…',
    'placeholder.initializing': 'Initializing session…',
    'placeholder.select_script': 'Select a script to start',
    'back': 'Back',
    'search.title': 'Search',
    'search.placeholder': 'Search scripts or descriptions…',
    'nav.home': 'Start',
    'nav.chat': 'Load',
    'nav.create': 'Create',
    'nav.profile': 'Profile',
    'profile.title': 'Profile',
    'profile.uploadAvatar': 'Upload Avatar',
    'profile.displayName': 'Display Name',
    'profile.language': 'Language',
    'profile.save': 'Save',
    'settings.title': 'Settings',
    'settings.privacy': 'Privacy & Security',
    'settings.telemetry': 'Allow anonymous usage data (help improve product)',
    'settings.dataRetention': 'Data retention period',
    'settings.retention.never': 'Never auto-delete',
    'settings.privacyPolicy': 'Privacy Policy',
    'settings.dataControl': 'Data & Account Control',
    'settings.dataControlDesc': 'You can export or delete local data, or delete account & data.',
    'settings.deleteData': 'Delete Local Data',
    'settings.deleteDataConfirm': 'Delete all local saves, chats, and creations? This cannot be undone.',
    'settings.deleted': 'Deleted',
    'settings.deletedMsg': 'Local data has been cleared.',
    'settings.deleteAccount': 'Delete Account & Data',
    'settings.deleteAccountConfirm': 'Delete account and associated data? In this build, local data will be removed.',
    'settings.usCompliance': 'Compliant with applicable US privacy laws (e.g., CCPA). We offer clear data controls and deletion options.',
    'profile.myGames': 'My Published Games',
    'profile.mySessions': 'My Saves',
    'profile.myFavorites': 'My Favorites',
    'profile.noGames': 'No games yet',
    'profile.noSessions': 'No saves yet',
    'profile.noFavorites': 'No favorites yet',
    'html.loading': 'Loading HTML…',
    'html.expand': 'Expand HTML',
    'html.collapse': 'Collapse HTML',
    'chatHistory.empty.title': 'No saves yet',
    'chatHistory.empty.subtitle': 'Pick a game on Home to start',
    'chatHistory.createNew': 'Create New Save',
    'chatHistory.confirmCreate': 'Create a new save for this game?',
    'chatHistory.title': 'Load',
    'chatHistory.rename': 'Rename',
    'chatHistory.delete': 'Delete',
    'chatHistory.confirmDelete': 'Delete this save?',
    // Bookshelf sections
    'bookshelf.section.recent': 'Recently Read',
    'bookshelf.section.monthAgo': 'Over a month ago',
    'bookshelf.section.yearAgo': 'Over a year ago',
    'create.title.edit': 'Edit My Game',
    'create.title.new': 'Create My Adventure',
    'create.placeholder.title': 'Title',
    'create.placeholder.content': 'Write opening story, world, settings…',
    'create.save': 'Save',
    'create.saveDraft': 'Save Draft',
    'create.submit': 'Submit',
    'create.prompt.placeholder': 'Write the Prompt (guide the generation)',
    'create.prologue.placeholder': 'Write the Prologue (opening of the story)',
    'create.help.cover': 'Cover: click the top-right image icon to upload. Used for list and background; prefer a clear landscape image.',
    'create.help.title': 'Title is used for display and search; keep it short and expressive.',
    'create.help.prompt': 'Prompt guides the model’s style/world; be specific and clear.',
    'create.help.prologue': 'Prologue is the opening content users see first; set tone and context.',
    'confirm.ok': 'Confirm',
    'confirm.cancel': 'Cancel',
    // Errors
    'error.title': 'Error',
    'error.categories.load': 'Failed to load categories. Please try again later.',
    'error.adventures.load': 'Failed to load adventures. Please try again later.',
    'error.session.delete': 'Failed to delete the save',
    // WebSocket
    'ws.connecting': 'Connecting to server…',
    'ws.reconnecting': 'Connection lost, retrying… (attempt {n})',
    'ws.disconnected': 'Disconnected',
    'ws.retry': 'Reconnect',
    // Common
    'common.expand': 'Expand',
    'common.collapse': 'Collapse',
    'common.next': 'Next',
    'common.prev': 'Previous',
    'common.selected': 'Selected',
    'common.chooseImage': 'Choose Image',
    'common.loading': 'Loading…',
    // Favorites
    'favorite.add': 'Favorite',
    'favorite.remove': 'Unfavorite',
    // Profile
    'profile.signOut': 'Sign out',
    'profile.user': 'User',
    'profile.loginRequired': 'Please sign in to view your saves and creations',
    // Create/Editor
    'create.field.titleLabel': 'Title',
    'create.section.promptTitle': 'Background',
    'create.section.gameTypeTitle': 'Game Type',
    'create.section.step3Title': 'Characters & Scenes',
    'create.section.step4Title': 'Naming & Cover',
    'create.gameType.placeholder': 'Select a game type',
    'create.gameType.AVG': 'AVG (Visual Novel)',
    'create.gameType.SIM': 'SIM (Simulation)',
    'create.gameType.RPG': 'RPG (Role Playing)',
    'create.gameType.CUSTOM': 'CUSTOM (Provide UI)',
    'create.step2.subtitle': 'Fill settings and opening',
    'create.step3.characters': 'Characters',
    'create.step3.addCharacter': 'Add Character',
    'create.step3.scenes': 'Scenes',
    'create.step3.addScene': 'Add Scene',
    'create.scene.mainInitial': 'Main Character Initial Scene',
    'create.scene.mainInitial.yes': 'Yes',
    'create.scene.mainInitial.no': 'No',
    'create.character.initialScene': 'Initial Scene',
    'create.character.name': 'Character Name',
    'create.character.description': 'Character Description',
    'create.character.image': 'Character Image',
    'create.scene.name': 'Scene Name',
    'create.scene.description': 'Scene Description',
    'create.scene.image': 'Scene Image',
    'create.scene.connections': 'Connections',
    'create.scene.connections.tip': 'Scenes reachable from this scene',
    'create.modal.add': 'Add',
    'create.modal.save': 'Save',
    'create.modal.cancel': 'Cancel',
    'create.modal.edit': 'Edit',
    'create.tip.customUiOnly': 'UI code editable only for CUSTOM type',
    'create.cover.title': 'Cover / Background Image',
    'create.cover.tip': 'Prefer clear landscape images',
    'create.cover.chosenBadge': 'Selected',
    'create.cover.pickImage': 'Pick Image',
    'create.category.title': 'Choose Category',
    'create.category.tip': 'For classification and recommendations',
    'create.category.placeholder': 'Select a category',
    'create.category.empty': 'No categories',
    'create.advanced.title': 'Advanced Options',
    'create.advanced.subtitle': 'Custom UI code (optional)',
    'create.advanced.uiCodeLabel': 'Game UI Code (optional)',
    'create.advanced.uiCodePlaceholder': 'Paste or write UI code (optional)',
    'create.advanced.openDesigner': 'Open UI Designer',
    // Create assets
    'create.assets.title': 'Assets',
    'create.assets.tip': 'Upload images and copy URLs for the UI Designer',
    'create.assets.upload': 'Upload Asset Image',
    'create.assets.listEmpty': 'No assets yet',
    'create.assets.copy': 'Copy URL',
    'create.assets.copied': 'Copied',
    'create.assets.uploadedMsg': 'Asset uploaded',
    'create.prologue.title': 'Prologue',
    'create.prologue.tip': 'Opening of the story',
    'create.submit.success': 'Submitted',
    'create.submit.failed': 'Submit failed',
    'create.image.uploaded': 'Uploaded',
    'create.image.coverUpdated': 'Cover updated',
    'create.image.uploadFailed': 'Upload failed',
    'error.network': 'Network error',
    'create.draftSaved': 'Draft saved',
    'create.exitConfirm': 'Exit editing? Unsaved changes will be kept as draft.',
    'create.submit.missingFields': 'Please complete title, prologue and cover before submitting',
    'error.deleteFailed': 'Delete failed',
    // UI Designer
    'uiDesigner.title': 'UI Designer',
    'uiDesigner.preview.placeholder': 'Chat examples will show here…',
    'uiDesigner.sample.userHello': 'User: Hello!',
    'uiDesigner.sample.welcome': 'System: Welcome to the UI Designer preview.',
    'uiDesigner.input.placeholder': 'Type test content…',
    'uiDesigner.send': 'Send',
    // Settings extras
    'settings.reauthRequired': 'Please re-authenticate and try deleting the account again.',
    // Auth
    'auth.login': 'Sign In',
    // Misc
    'common.all': 'All',
    'home.refreshed': 'Refreshed',
};
const dicts = {
    'zh-CN': zhCN,
    'en-US': enUS,
};
export function translate(lang, key) {
    const d = dicts[lang] || zhCN;
    return d[key] || key;
}
export function useT() {
    const [lang] = useAtom(languageAtom);
    return (key) => translate(lang, key);
}
